import { endpoint } from '../shared-api.service';
import { PublicSharedApiService } from '../public-shared-api.service';

export type OgpSsoEnforcedResponse = {
  isOgpSsoEnforced: boolean;
};

const publicSharedApi = new PublicSharedApiService(endpoint);

export const getOgpSsoEnforced = async (email: string): Promise<OgpSsoEnforcedResponse> => {
  const trimmed = email.trim();

  return publicSharedApi.get<OgpSsoEnforcedResponse>({ path: `ogp-sso-enforced/${trimmed}` });
};
